import React from 'react';
import SavedScoutingsDatatable from "./components/datatable/SavedScoutingsDatatable";
import rows from './components/ScoutingsRows';
import FilterToolbar from "../../../ui/filters/FilterToolbar";
import {Scouting} from "./FiltersConfig";

class SavedScoutings extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            rows: rows
        }
    }

    filtersConfig = () => {
        return Scouting;
    };

    renderFilters = () => {
        const filters = this.filtersConfig();
        return <FilterToolbar filters={filters} size="sm" color="primary"/>;
    };

    render() {
        var showPagination = this.state.rows.length > 30;
        return (
            <div className="saved-scoutings scoutings">
                {this.renderFilters()}
                <SavedScoutingsDatatable
                    rows={JSON.parse(JSON.stringify(this.state.rows))}
                    showPagination={showPagination}
                />
            </div>
        )
    }
}

export default SavedScoutings;
